import { jwtDecode } from "jwt-decode";
/**
 * Decode JWT and return an additional `expired` flag so we can regenerate the session.
 */ function getJwtPayload(jwt, expireBeforeDays = 16) {
    const decoded = jwtDecode(jwt);
    const isValidUntil = new Date(decoded.validUntil);
    const expiresIn = isValidUntil.getTime() - 1000 * 60 * 60 * 24 * expireBeforeDays;
    return {
        ...decoded,
        isValidUntil,
        expired: new Date().getTime() >= expiresIn
    };
}
export { getJwtPayload };
